import React from 'react';

import { SvgIconId } from 'client/bundles/types';

import { icons } from './icons';

export const getIcon = (id: SvgIconId): () => React.ReactElement => icons[id];
